import { patch } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

const useProposeNewRateParamsSchema = z.object({
  shiftId: z.string(),
  payRate: z.number(),
});

const useProposeNewRateResponseSchema = z.object({
  negotiation: z.object({ _id: z.string() }),
});

export type UseProposeNewRateParams = z.infer<typeof useProposeNewRateParamsSchema>;
export type UseProposeNewRateResponse = z.infer<typeof useProposeNewRateResponseSchema>;

export function useProposeNewRate(
  params: {
    rateNegotiationId: string | undefined;
  },
  options: UseMutationOptions<
    UseProposeNewRateResponse,
    AxiosError<UseProposeNewRateResponse>,
    UseProposeNewRateParams
  > = {}
) {
  const { rateNegotiationId } = params;

  return useMutation({
    mutationFn: async (data) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/negotiation/${rateNegotiationId}/propose`,
        data,
        requestSchema: useProposeNewRateParamsSchema,
        responseSchema: useProposeNewRateResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.CREATE_NEGOTIATION_FAILURE,
    },
    ...options,
  });
}
